import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <Helmet>
        <title>Sarvaay Academy</title>
        <meta http-equiv="refresh" content="1;URL='/login'" />   
        <meta
          name="description"
          content="Sarvaay Academy - Connect and share your content!"
        />
        <meta name="keywords" content="Sarvaay Academy, Walls, Connect, Share" />
        <link rel="apple-touch-icon" href="%PUBLIC_URL%/icon/main-logo.png" />
      </Helmet>
      {/* Add a Link to the Login page */}
      <Link to="/login" className="btn theme-button">
        Go to Login Page
      </Link>
    </div>
  );
};

export default Home;
